// extracted by mini-css-extract-plugin
module.exports = {"container":"form-drop-down_container__2xJX3","label":"form-drop-down_label__eN0lp","error":"form-drop-down_error__2ANLi","borderError":"form-drop-down_borderError__3nyum"};